import { Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type CustomerType = 1 | 2;

export interface Customer {
  id?: number;
  firstName?: string;
  lastName?: string;
  otherName?: string;
  phoneNo?: string;
  customerName?: string;
  residentialAddress?: string;
  officeAddress?: string;
  officePhoneNo?: string;
  taxId?: string;
  customerType?: CustomerType;
  name?: string;
  intlPassportNo?: string;
  driversLicense?: string;
  votersId?: string;
  emailAddress?: string;
  gender?: number;
  nationalityId?: number;
  nationalId?: string;
  religionId?: string;
  maritalStatus?: number;
  placeOfBirth?: string;
  mothersMaidenName?: string;
}

class CustomerService extends BaseService {
  async getCustomers(params: {
    id?: number[];
    name?: string;
    phoneNo?: string;
    pageIndex?: number;
    recordCount?: number;
  }): Promise<Result<Customer[]>> {
    const queryStringParams = this.ToQueryString(params);
    return this.get<Result<Customer[]>>(`customers${queryStringParams}`);
  }

  async deleteCustomer(customerid: number): Promise<any | Result<boolean>> {
    return this.delete<Result<boolean>>(`customers/${customerid}`);
  }

  async getCustomer(customerid: number): Promise<Result<Customer> | any> {
    return await this.get<Result<Customer>>(`customers/${customerid}`);
  }

  async onBoardCustomer(customer: Customer): Promise<Result<Customer>> {
    return await this.post<Result<Customer>>("customers", customer);
  }

  async createOrUpdateCustomer(
    customer: Customer
  ): Promise<Result<Customer | boolean>> {
    const customerId: string =
      customer.id !== undefined ? `/${customer.id}` : "";
    return await this.post<Customer | any>("customers" + customerId, customer);
  }

  async getCustomerNextOfKins(params: {
    customerId: number;
    name?: string;
    phoneNo?: string;
    nokId?: number;
  }): Promise<any> {
    let queryParams = "";
    if (params.name !== undefined && params.name !== "") {
      queryParams += "name=" + params.name;
    }

    if (params.phoneNo != undefined && params.phoneNo !== "") {
      queryParams += "phoneNo=" + params.phoneNo;
    }

    if (params.nokId) {
      queryParams += "nokId=" + params.nokId;
    }

    return this.get<Result<Customer>>(`customers/${params.customerId}`);
  }

  async getNextOfKin(nokId: number): Promise<any> {
    return this.get<Result<Customer>>(`api/nok/${nokId}`);
  }

  async deleteNextOfKin(nokId: number): Promise<any> {
    return this.delete<Result<boolean>>(`api/nok/${nokId}`);
  }

  async addOrUpdateCustomerNextOfKin(
    customerId: number,
    params: {
      id?: number;
      firstName: string;
      lastName: string;
      otherName: string;
      dateOfBirth?: Date;
      residentialAddress: string;
      officeAddress?: string;
      phoneNo: string;
      email?: string;
    }
  ): Promise<any> {
    if (params.id === 0) {
      return this.post(`customers/${customerId}/nok`, params);
    } else {
      return this.put(`customers/${customerId}/nok/${params.id}`, params);
    }
  }
}

export default new CustomerService();
